import Text from './Text';
import {
  HeroBanner,
  H1,
  H2,
  H3,
  BodyText,
  SubBodyText,
  CaptionText,
} from './Heading';
import PriceText from './PriceText';

export {
  HeroBanner,
  H1,
  H2,
  H3,
  BodyText,
  SubBodyText,
  CaptionText,
  Text,
  PriceText,
};
